import { FromJsonParser } from "../../../shared/types/parser";
import { Self } from "../types/self";

export const parserSelf: FromJsonParser<Self> = {
    fromJson: (json) => ({
        self: json['.self']
    })
}